import styled from 'styled-components';

export const FotoContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 29.7em;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const FotoResponsiveIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;